import useTraplinkedReportComments from "../../hooks/useTraplinkedReportComments";
import { ServiceInfo } from "../../pages/Customer/Dashboard/ServiceInfo";
import { Comments } from "../Comments/Comments";

import styles from "./traplinkedReportModal.module.css";

type TraplinkedReportModalProps = {
  isOpen: boolean;
  onClose: () => void;
  monitorDetails: any;
  propertyAreaId?: string;
  service: any;
  onCommentsUpdated?: (count: number) => void;
};

export const TraplinkedReportModal = ({
  isOpen,
  onClose,
  monitorDetails,
  propertyAreaId,
  service,
  onCommentsUpdated,
}: TraplinkedReportModalProps) => {
  const { comments, loadingComments, addComment } = useTraplinkedReportComments(
    service.monitorId,
    service.id,
    propertyAreaId
  );
  console.log(monitorDetails);
  if (!isOpen) return null;
  return (
    <div className={styles["modal-overlay"]} onClick={onClose}>
      <div
        className={styles["modal-content"]}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles["close-button"]} onClick={onClose}>
          &times;
        </button>
        <p className={styles["name"]}>
          {monitorDetails.name} {monitorDetails.number}
        </p>
        <ServiceInfo service={service} automaticMessages />

        <Comments
          comments={comments}
          addComment={async (content: string) => {
            await addComment(content);
        
            onCommentsUpdated?.(comments.length + 1);
          }}
          loading={loadingComments}
        />
      </div>
    </div>
  );
};
